import Child from '@/models/enrollment/child';
import ChildIdentity from '@/models/enrollment/childIdentity';
import EmailInvitationModel from '@/models/enrollment/emailInvitationModel';
import SchoolArrangement from '@/models/enrollment/schoolArrangement';
import ChildServiceCommands from '@/services/child/childService.commands';

export default {
  saveChildInfo({ commit }: any, child: Child) {
    return ChildServiceCommands.saveChildInfo(child).then(
      (success: any) => {
        commit('addChildInfo', success.data);

        return Promise.resolve(success.data);
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );
  },
  
  updateChildInfo({ commit }: any, child: ChildIdentity) {
    return ChildServiceCommands.updateChildInfo(child).then(
      (success: any) => {
        commit('updateChildInfo', child);

        return Promise.resolve(success.data);
      },
      (error:any) => {
        return Promise.reject(error);
      }
    );
  },

  updateSchoolArrangement({ commit }: any, schoolArrangement: SchoolArrangement) {
    return ChildServiceCommands.updateSchoolArrangement(schoolArrangement).then(
      (success: any) => {
        commit('updateSchoolArrangement', schoolArrangement);

        return Promise.resolve(success.data);
      },
      (error:any) => {
        return Promise.reject(error);
      }
    );
  },

  saveSchoolArrangement({ commit }: any, schoolArrangement: SchoolArrangement) {
    return ChildServiceCommands.saveSchoolArrangementInfo(schoolArrangement).then(
      (success: any) => {
        commit('updateSchoolArrangement', schoolArrangement);

        return Promise.resolve(success.data);
      },
      (error:any) => {
        return Promise.reject(error);
      }
    );
  },

  saveCustodyArrangement({ commit }: any, custodyArrangement: any) {
    return ChildServiceCommands.saveCustodyArrangement(custodyArrangement).then(
      success => {
        commit('updateCustodyArrangement', success.data);

        return Promise.resolve();
      },
      error => {   
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateCustodyArrangement({ commit }: any, custodyArrangement: any) {
    return ChildServiceCommands.updateCustodyArrangement(custodyArrangement).then(
      success => {
        commit('updateCustodyArrangement', success.data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  savePhysicalRequirements({ commit }: any, data: any) {
    return ChildServiceCommands.savePhysicalRequirements(data).then(
      success => {
        commit('updatePhysicalRequirements', data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updatePhysicalRequirements({ commit }: any, data: any) {
    return ChildServiceCommands.updatePhysicalRequirements(data).then(
      success => {
        commit('updatePhysicalRequirements', data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  saveEmergencyContacts({commit}: any, { childId, emergencyContacts }: any) {
    return ChildServiceCommands.saveEmergencyContacts(childId, emergencyContacts).then(
      success => {
        commit('updateEmergencyContacts', { childId, emergencyContacts });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateEmergencyContacts({ commit }: any, { childId, emergencyContacts }: any) {
    return ChildServiceCommands.updateEmergencyContacts(childId, emergencyContacts).then(
      success => {
        commit('updateEmergencyContacts', {childId, emergencyContacts});

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  savePickupPersons({ commit }: any, { childId, pickupPersons }: any) {
    return ChildServiceCommands.savePickupPersons(childId, pickupPersons).then(
      success => {
        commit('updatePickupPersons', { childId, pickupPersons });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updatePickupPersons({ commit }: any, { childId, pickupPersons }: any) {
    return ChildServiceCommands.updatePickupPersons(childId, pickupPersons).then(
      success => { 
        commit('updatePickupPersons', { childId, pickupPersons });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  saveSleepArrangement({ commit }: any, data: any) {
    return ChildServiceCommands.saveSleepArrangement(data).then(
      success => { 
        commit('updateChildSleepArrangement', data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateSleepArrangement({ commit }: any, data: any) {
    return ChildServiceCommands.updateSleepArrangement(data).then(
      success => {
        commit('updateChildSleepArrangement', data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateAdditionalEmergencyInfo({ commit }: any, { childId, additionalEmergencyInfo }: any) {
    return ChildServiceCommands.updateAdditionalEmergencyInfo(childId,additionalEmergencyInfo).then(
      success => {
        commit('updateAdditionalEmergencyInfo', { childId,additionalEmergencyInfo });

        return Promise.resolve(success);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  saveAdditionalEmergencyInfo({ commit }: any, { childId, additionalEmergencyInfo }: any) {
    return ChildServiceCommands.saveAdditionalEmergencyInfo(childId, additionalEmergencyInfo).then(
      success => {
        commit('updateAdditionalEmergencyInfo', { childId, additionalEmergencyInfo });

        return Promise.resolve(success);
      },
      error => {
        return Promise.reject(error);
      }
    );
  },  

  saveAdditionalInfo({ commit }: any, { childId, additionalInfo }: any) {
    return ChildServiceCommands.saveAdditionalInfo(childId, additionalInfo).then(
      success => {
        commit('updateAdditionalInfo', { childId, additionalInfo });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateAdditionalInfo({ commit }: any, { childId, additionalInfo }: any) {
    return ChildServiceCommands.updateAdditionalInfo(childId, additionalInfo).then(
      success => {
        commit('updateAdditionalInfo', { childId, additionalInfo });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  saveImmunization({ commit }: any, { childId, form }: any) {
    return ChildServiceCommands.saveChosenVaccinationDates(form).then(
      success => {
        commit('updateChildrenVaccinationDates', {
          childId: childId,
          childrenVaccinationDates: success.data
        });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateImmunization({ commit }:any, { childId, form }: any) {
    return ChildServiceCommands.updateChosenVaccinationDates(form).then(
      success => {
        commit('updateChildrenVaccinationDates', {
          childId: childId,
          childrenVaccinationDates: success.data
        });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  saveAllergyInfo({ commit }: any, { childId, allergyModel }: any) {
    return ChildServiceCommands.saveAllergyInfo(childId, allergyModel).then(
      success => {
        commit('updateChildAllergyInfo', { childId, allergyModel });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateAllergyInfo({ commit }: any, { childId, allergyModel }: any) {
    return ChildServiceCommands.updateAllergyInfo(childId, allergyModel).then(
      success => {
        commit('updateChildAllergyInfo', { childId, allergyModel });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },  

  updateHealthInfo({ commit }: any, { childId, healthInfoModel }: any) {
    return ChildServiceCommands.updateHealthInfo(childId, healthInfoModel).then(
      success => {
        commit('updateHealthInfo', { childId, healthInfo: healthInfoModel });

        return Promise.resolve(success.data);
      },
      error => {
        return Promise.reject(error);
      }
    );
  },

  saveHealthInfo({ commit }: any, { childId, healthInfoModel }: any) {
    return ChildServiceCommands.saveHealthInfo(childId, healthInfoModel).then(
      success => {
        commit('updateHealthInfo', { childId, healthInfo: healthInfoModel });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  }, 

  saveFeedingArrangment({ commit }: any, { childId, data }: any) {
    return ChildServiceCommands.saveFeedingArrangment(childId, data).then(
      success => {
        commit("updateChildFeedingArrangement", { childId, feedingArrangement: data });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");
        
        return Promise.reject(error);
      }
    );
  },

  updateFeedingArrangment({ commit }: any, { childId, data }: any) {
    return ChildServiceCommands.updateFeedingArrangment(childId, data).then(
      success => {
        commit("updateChildFeedingArrangement", { childId, feedingArrangement: data });
        
        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  }, 

  saveSkinProducts({ commit }: any, { childId, skinProductsModel }: any) {
    return ChildServiceCommands.saveSkinProducts(childId, skinProductsModel).then(
      success => {
        commit("updateChildSkinProducts", { childId, skinProducts: skinProductsModel });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateSkinProducts({ commit }: any, { childId, skinProductsModel }: any) {
    return ChildServiceCommands.updateSkinProducts(childId, skinProductsModel).then(
      success => {
        commit("updateChildSkinProducts", { childId, skinProducts: skinProductsModel });

        return Promise.resolve(success.data);
      },
      error => {  
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  skipEnrollmentStep({ commit }: any, { childId, stepCompleted }: any) {
    return ChildServiceCommands.skipEnrollmentStep(childId,stepCompleted).then(
      success => {
        commit('updateChild', success.data);

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  },

  updateCurrentViewedStep({ commit }: any, { childId, step }: any) {
    return ChildServiceCommands.updateCurrentViewedStep(childId, step).then(
      success => {
        commit('SET_CURRENT_VIEWED_STEP', { childId, step });//,{ root: true });

        return Promise.resolve(success.data);
      },
      error => {
        alert("error");

        return Promise.reject(error);
      }
    );
  }, 

  putInQueue({ commit }: any) {
    return ChildServiceCommands.putInQueue()
    .then(function (response) {
      commit('setNumberInQueue', response.data.numberInQueue);

      return Promise.resolve(response);
    })
    .catch(function (error) {
      commit('setNumberInQueue', error.response.data.numberInQueue);

      return Promise.reject(error);
    }); 
  },

  sendEmailInvitation({ commit }: any, emailInvitationModel: EmailInvitationModel) {
    return ChildServiceCommands.sendInvitation(emailInvitationModel)
    .then(function (response) {
      return Promise.resolve(response);
    })
    .catch(function (error) {
      return Promise.reject(error);
    });
  },

  sendProviderEmailInvitation({ commit }: any, emailInvitationModel: EmailInvitationModel) {
    return ChildServiceCommands.sendProviderInvitation(emailInvitationModel)
    .then(function (response) {
      return Promise.resolve(response);
    })
    .catch(function (error) {
      return Promise.reject(error);
    });
  },  

  deleteChild({ commit }: any, payload: { id: string }) {
    return ChildServiceCommands.deleteChild(payload.id).then((success: any) => {
      commit('removeChild', payload.id);

      return Promise.resolve(success);
    }, (error: any) => {
      return Promise.reject(error);
    });
  },

  clear(context: any) {
    context.commit('clear');
  },
}